import { chatbotEnabledPages } from './src-config-ubik-config.js';

const isChatbotEnabled = (pageName) => {
  if (typeof window === "undefined" || !window.location) {
    console.warn("isChatbotEnabled can only be called in a browser environment with a valid window.location.");
    return false;
  }
  const pageURL = window.location.href;
  if (pageURL && pageURL.includes("localhost") || pageURL.includes("staging")) return true;
  if (pageName && chatbotEnabledPages.includes(pageName?.toLowerCase())) return true;
  if (pageURL && pageURL.includes("/customer-care/") && !pageURL.includes("order-help")) return true;
  return false;
};

export { isChatbotEnabled };
//# sourceMappingURL=src-utils-init-chatbot-utils.js.map
